import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export function useRefRedirect() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === '/poe2skillsplanner') {
      navigate('/poe2skillplanner', { replace: true });
    }
    else if (location.pathname === '/' && location.search.startsWith('?ref=')) {
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return location.pathname === '/poe2skillsplanner';
}
